export const I18N_LOCALES = {
    en: 'en-US',
    de: 'de-CH',
};
